var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('b-breadcrumb',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"},attrs:{"separator":"has-arrow-separator","size":"is-small"}},_vm._l((_vm.breadCrumbs),function(item){return _c('b-breadcrumb-item',{key:item.text,attrs:{"href":item.to}},[_vm._v(_vm._s(item.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }